var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpeakerOn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 14.5878V18.5878C7 20.2446 8.34315 21.5878 10 21.5878H12.5858C12.851 21.5878 13.1054 21.6931 13.2929 21.8807L17.2929 25.8807C17.9229 26.5106 19 26.0645 19 25.1736V8.002C19 7.1111 17.9229 6.66493 17.2929 7.2949L13.2929 11.2949C13.1054 11.4824 12.851 11.5878 12.5858 11.5878H10C8.34315 11.5878 7 12.9309 7 14.5878ZM22.149 25.1559C21.5719 25.395 21 24.9208 21 24.2961V24.1697C21 23.731 21.2916 23.3529 21.6808 23.1505C23.4473 22.2323 25 19.9106 25 16.5879C25 13.2653 23.4473 10.9436 21.6808 10.0254C21.2916 9.823 21 9.44491 21 9.0062V8.87976C21 8.25504 21.5719 7.78089 22.149 8.02001C24.9636 9.18612 27 12.5813 27 16.5879C27 20.5946 24.9636 23.9898 22.149 25.1559ZM22.2769 19.456C21.8775 20.1677 21 19.7779 21 18.9619V14.214C21 13.3979 21.8775 13.0082 22.2769 13.7198C22.7326 14.5318 23 15.5208 23 16.5879C23 17.6551 22.7326 18.6441 22.2769 19.456Z",
    fill: "#0071FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeakerOn);
export default __webpack_public_path__ + "static/media/speakerOn.0945eb0e2b5e0244de6e09304ed1d24a.svg";
export { ForwardRef as ReactComponent };